import * as actionTypes from './actionTypes';
import initialState from 'store/initialState';

export default function(state = initialState.quoteAppt, action) {
  switch (action.type) {
    case actionTypes.SET_QUOTE_CONFIRMATION_ID:
      return { ...state, quoteConfirmationId: action.payload };
    case actionTypes.SET_IS_QUOTE_APPT:
      return { ...state, isQuoteAppt: action.payload };
    case actionTypes.SET_READ_ONLY_SERVICES:
      return { ...state, readOnlyServices: action.payload };
    case actionTypes.SET_READ_ONLY_PACKAGE:
      return {
        ...state,
        readOnlyPackage: action.payload ? action.payload : {}
      };
    case actionTypes.SHOW_ERROR:
      return { ...state, showError: action.payload };
    case actionTypes.RESET_QUOTE_APPT:
      return {
        isQuoteAppt: false,
        showError: false,
        readOnlyServices: [],
        readOnlyPackage: {}
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/quoteAppt/reducer.js